<template>
  <div class="about-main">
    <div class="about-ab bgA10"
         :style="{minHeight: clientHeight + 'px'}">
      <div class="page-title">
        <h2>What is
          <span>Assistance</span>
        </h2>
        <h3 style="width:240px">救援服务的必要性</h3>
        <div class="page-scroll">
          <img :src="scroll"
               alt="">
        </div>
      </div>
    </div>
    <div class="about-ab bgA12"
         :style="{minHeight: clientHeight + 'px'}">
      <div class="page-content">
        <h2 class="content-title02">Specific Scene</h2>
        <h3 class="content-subtitle">什么情况需要救援服务</h3>
        <div class="page-inbound">
          <p>想象一下，如果在海外突发疾病或受伤时该怎么办？</p>
          <p>我们需要一个熟悉当地的亲友告诉我们该去哪里就诊。</p>
          <p>我们需要这个亲友有熟悉的医生并帮忙联系预约。</p>
          <p>我们需要这个亲友来家中接我们前往医院。</p>
          <p>我们需要这个亲友在就诊过程中帮忙翻译。</p>
          <p>我们需要这个亲友帮忙垫付医药费。</p>
          <p>更甚至，我们需要这个亲友陪同回国。</p>
          <p>即使是在我们熟悉的中国国内，</p>
          <p>我们想要就诊公立三甲医院的专家门诊时，</p>
          <p>也希望有亲友帮忙在凌晨去排队挂号，</p>
          <p>或者至少，能够把1个月后的预约号提前到一周以内。</p>
          <p>&nbsp;</p>
          <p>而，谁能有幸，可以在全球拥有这样的亲友呢？</p>
          <p>威马捷愿意成为您的亲友，为您提供安心的全球救援服务。</p>
        </div>
      </div>
    </div>
    <div class="about-ab bgA05"
         :style="{minHeight: clientHeight + 'px'}">
      <div class="page-content">
        <h2 class="content-title01">Necessity</h2>
        <h3 class="content-subtitle">「谁」需要援助服务</h3>
        <Carousel style="width: 840px;margin: 0 auto"
                  v-model="carouselIndex"
                  :autoplay="carouselSetting.autoplay"
                  :autoplay-speed="carouselSetting.autoplaySpeed"
                  :dots="carouselSetting.dots"
                  :radius-dot="carouselSetting.radiusDot"
                  :trigger="carouselSetting.trigger"
                  :arrow="carouselSetting.arrow">
          <CarouselItem>
            <div class="assis-item">
              <h5 class="assis-title">【希望出国进行健康体检或专门治疗的客人】</h5>
              <div class="assis-con">
                <img :src="assistance1"
                     alt="">
                <div>
                  <p>北京于2010年開始提供国际医疗协调服务。</p>
                  <p>作为日资企业，利用自身优势与日本各大国立医院、大学附属医院、著名私立医院以及小型专科医院和诊所建立了长期密切的合作关系。主要合作医院以东京、大阪、神户为中心，覆盖了北海道到九州的日本全国。同时北京威马捷也是德国海德堡大学医院、意大利圣拉斐尔医院、意大利圣多纳托医院、意大利盖世骨科医院、新加坡伊丽莎白乌节路医院、新加坡伊丽莎白诺维娜医院、新加坡鹰阁医院、新加坡百汇东岸医院等官方指定合作机构，并与美国、中国香港等地的医疗集团展开合作。</p>
                  <p>威马捷的年咨询量高达3000例以上，累积了大量的经验，可以根据每位客户需求，提供定制方案。</p>
                </div>
              </div>
            </div>
          </CarouselItem>
          <CarouselItem>
            <div class="assis-item">
              <h5 class="assis-title">【国内外旅游人士】</h5>
              <div class="assis-con">
                <img :src="assistance2"
                     alt="">
                <div>
                  <p>威马捷与各大保险公司合作，为国内外旅游人士提供包括旅行当地的就医安排，紧急移送及转运回国等全球紧急救援服务。</p>
                </div>
              </div>
            </div>
          </CarouselItem>
          <CarouselItem>
            <div class="assis-item">
              <h5 class="assis-title">【在境外工作、或境外出差频繁的人士】</h5>
              <div class="assis-con">
                <img :src="assistance3"
                     alt="">
                <div>
                  <p>威马捷根据企业的委托，以定制服务模式为会员提供海外预估风险预案及紧急救援服务。</p>
                </div>
              </div>
            </div>
          </CarouselItem>
          <CarouselItem>
            <div class="assis-item">
              <h5 class="assis-title">【中国国内的持有保险的外籍人士及持有商业医疗保险的中国患者】</h5>
              <div class="assis-con">
                <img :src="assistance4"
                     alt="">
                <div>
                  <p>威马捷与国内外保险公司及救援公司合作，为在中国国内需要高端医疗服务的客人提供紧急救援服务。</p>
                </div>
              </div>
            </div>
          </CarouselItem>
          <CarouselItem>
            <div class="assis-item">
              <h5 class="assis-title">【其他，中国境内外有紧急救援或转运需求的患者】</h5>
              <div class="assis-con">
                <img :src="assistance5"
                     alt="">
                <div>
                  <p>威马捷可以根据医院，领事馆，大型活动举办方的需求，为有需要的客人提供全球紧急救援服务。</p>
                </div>
              </div>
            </div>
          </CarouselItem>
        </Carousel>
      </div>
    </div>
    <div class="under-link">
      <ol class="under-link-wrap">
        <li>
          <router-link to="/about">
            <span>关于威马捷</span>
            <i class="link-arrow"></i>
          </router-link>
        </li>
        <li>
          <router-link to="/activities">
            <span>威马捷服务</span>
            <i class="link-arrow"></i>
          </router-link>
        </li>
        <li>
          <router-link to=""
                       class="active">
            <span>医疗救援的必要性</span>

          </router-link>
        </li>
      </ol>
    </div>
  </div>
</template>
<script>
import assistance1 from '@/assets/images/about/assistance1.png'
import assistance2 from '@/assets/images/about/assistance2.png'
import assistance3 from '@/assets/images/about/assistance3.png'
import assistance4 from '@/assets/images/about/assistance4.png'
import assistance5 from '@/assets/images/about/assistance5.png'
import scroll from '@/assets/images/about/about_scroll.png';
import service from '@/assets/images/rescue/icon-service.png'
import global from '@/assets/images/home/icon-link1.png'
export default {
  data () {
    return {
      assistance1,
      assistance2,
      assistance3,
      assistance4,
      assistance5,
      scroll,
      global,
      service,
      carouselIndex: 0,
      carouselSetting: {
        autoplay: false,
        autoplaySpeed: 2000,
        dots: 'outside',
        radiusDot: true,
        trigger: 'click',
        arrow: 'always'
      },
      clientHeight: ''
    }
  },
  mounted () {
    var h = document.documentElement.clientHeight || document.body.clientHeight;

    this.clientHeight = h;
    // console.log(this.clientHeight)
  }
}
</script>
<style lang="less" scoped>
.assis-item {
  background: #fff;
  padding: 20px;
}
.assis-title {
  font-size: 24px;
  color: rgb(0, 112, 192);
  text-align: center;
  margin-bottom: 20px;
}
.assis-con {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  img {
    width: 326px;
    height: 250px;
    margin-right: 10px;
  }
  div {
    width: 480px;
  }
  p {
    font-size: 16px;
    line-height: 20px;
    text-indent: 32px;
  }
}
.about-main {
  width: 100%;
  height: auto;
  margin: 0 auto;
  padding: 0;
  clear: both;
  zoom: 1;
  position: relative;
  z-index: 0;
}
.about-ab {
  width: 100%;
  padding: 60px 0;
  background-size: cover;
  background-attachment: fixed;
  background-repeat: no-repeat;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.bgA05 {
  background-image: url('../assets/images/about/about_top_bg121.png');
  background-position: center top;
}
.bgA10 {
  background-image: url('../assets/images/about/about_top_bg09.png');
  background-position: center top;
}
.bgA11 {
  background-image: url('../assets/images/about/about_top_bg10.jpg');
  background-position: center top;
}
.bgA12 {
  background-color: #2c4063;
  background-image: url('../assets/images/about/about_top_bg03.png');
  background-position: center 88%;
  background-size: 80%;
}
.page-title:before {
  position: absolute;
  left: 0;
  top: 0;
  content: '';
  display: block;
  width: 10px;
  height: 60px;
  background: none;
}
.page-title {
  background: none!important;
  h2 {
    font-size: 60px;
    color: #fff;
    line-height: 70px;
    text-align: center;
    margin-bottom: 28px;
    span {
      color: #cf1300;
    }
  }
  h3 {
    width: 204px;
    height: 58px;
    background: rgba(0, 0, 0, 0.3);
    border: 2px solid #fff;
    color: #fff;
    font-size: 28px;
    line-height: 28px;
    text-align: center;
    line-height: 58px;
    margin: 0 auto 34px;
  }
  .page-scroll {
    width: 80px;
    height: 80px;
    margin: 0 auto;
  }
}
.page-content {
  .content-title01 {
    font-size: 60px;
    color: #444;
    line-height: 80px;
    text-align: center;
  }
  .content-title02 {
    font-size: 60px;
    color: #fff;
    line-height: 80px;
    text-align: center;
  }
  .content-subtitle {
    width: 280px;
    height: 40px;
    background: #ab291b;
    font-size: 24px;
    color: #fff;
    line-height: 40px;
    text-align: center;
    padding: 0 14px;
    margin: 0 auto 36px;
  }
  .content-text {
    width: 686px;
    background: #fcfcfc;
    padding: 40px 0 24px;
    margin: 0 auto;
    .content-para {
      margin-bottom: 26px;
    }
    p {
      font-size: 14px;
      color: #444;
      line-height: 26px;
      text-align: center;
    }
  }
}

.demo-carousel {
  position: relative;
  width: 686px;
  height: 354px;
  background: #ddedf5;
  padding: 50px;
  img {
    position: absolute;
    left: 0;
    top: 0;
    width: 168px;
    height: 157px;
  }
  .carouselTitle {
    font-size: 20px;
    color: #0f6aa1;
    line-height: 36px;
    text-align: center;
    margin: 0 auto 20px;
  }
  .carouselContent {
    p {
      color: #444;
      font-size: 16px;
      line-height: 26px;
      text-align: center;
    }
  }
}
.page-inbound {
  // display: flex;
  width: 838px;
  height: 385px;
  // flex-direction: row;
  // align-items: center;
  // justify-content: center;
  background: rgba(255, 255, 255, 0.8);
  // flex-wrap: wrap;
  padding: 10px 0;

  p {
    font-size: 19px;
    color: #444444;
    line-height: 26px;
    text-align: left;
    margin-left: 200px;
  }
}
.under-link {
  background: #fff;
  padding: 50px 0;
  .under-link-wrap {
    width: 700px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0 auto;
    li {
      width: 160px;
      height: 160px;
      margin: 0 auto;
      a {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        border: solid 2px #aa2619;
        color: #aa2619;
        border-radius: 50%;
        span {
          display: block;
          display: block;
          margin-top: 40px;
          font-size: 16px;
        }
        .link-arrow {
          display: block;
          width: 20px;
          height: 20px;
          margin-top: 20px;
          background: url('../assets/images/about/arrow-circle-up.png')
            no-repeat center;
          background-size: 100% auto;
        }
      }
      a.active {
        color: #fff;
        background-color: #aa2619;
        span {
          margin-top: 2px;
        }
      }
    }
  }
}
.page-serve {
  padding: 50px 0;
  h4 {
    font-size: 26px;
    color: #333130;
    line-height: 30px;
    text-align: center;
    margin-bottom: 34px;
  }
  .serve-customer {
    width: 1000px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    margin: 0 auto;
    div {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 300px;
      height: 110px;
      background: #fff;
      border: 1px solid #d6d6d6;
      padding: 20px;
      img {
        width: 60px;
        height: 60px;
        margin-right: 16px;
      }
      p {
        font-size: 30px;
        color: #ae1e10;
        line-height: 60px;
      }
    }
  }
}
.service-flex {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  width: 1024px;
  background: #fff;
  padding: 20px 50px;
  .service-about {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    width: 410px;
    margin-bottom: 35px;
    .service-icon {
      display: inline-block;
      width: 70px;
      height: 70px;
      background: url('../assets/images/rescue/icon-service.png') no-repeat;
      margin-right: 18px;
    }
    .service01 {
      background-position: 0 0;
    }
    .service02 {
      background-position: 0 -80px;
    }
    .service03 {
      background-position: 0 -160px;
    }
    .service04 {
      background-position: 0 -240px;
    }
    .service05 {
      background-position: 0 -319px;
    }
    .service06 {
      background-position: 0 -399px;
    }
    .service07 {
      background-position: 0 -479px;
    }
    .service08 {
      background-position: 0 -559px;
    }
    .service09 {
      background-position: 0 -639px;
    }
    .service10 {
      background-position: 0 -719px;
    }
    .service-content {
      h5 {
        font-size: 18px;
        color: #191919;
        line-height: 30px;
        margin-bottom: 15px;
      }
      p {
        font-size: 14px;
        color: #6e6671;
        line-height: 20px;
      }
    }
  }
}
</style>
<style lang="less">
.ivu-carousel {
  .ivu-carousel-arrow {
    width: 80px;
    height: 80px;
    font-size: 4em;
  }
  .ivu-carousel-arrow.left {
    left: -20%;
  }
  .ivu-carousel-arrow.right {
    right: -20%;
  }
}
.ivu-carousel-dots li {
  width: 30px;
  height: 30px;
  button {
    opacity: 1;
  }
  button.radius {
    width: 30px;
    height: 30px;
    background: #fff;
  }
}
.ivu-carousel-dots li.ivu-carousel-active > button.radius {
  width: 30px;
  height: 30px;
  background: #a3362d;
}
</style>
